<template>
	<page>
		<module title="充值记录详情">
			<c-detail >
				<c-detail-item label="充值单号" >
					{{detailData.record_number}}
				</c-detail-item>
				<!-- <c-detail-item label="交易状态" >
					<template v-slot="{data}">
						<span style="color:green" v-if="detailData.payment_state==2">已支付</span>
						<span style="color:gray" v-if="detailData.payment_state==1">待支付</span>
					</template>
				</c-detail-item> -->
				<c-detail-item label="充值金额" >
					<template v-slot="{data}">
						<span>￥{{(detailData.money||0).toFixed(2)}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="支付渠道" >
					<template v-slot="{data}">
						<span v-if="detailData.payment_state==1">--</span>
						<span v-else>{{detailData.payment_type}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="第三方支付单号" >
					{{detailData.third_number}}
				</c-detail-item>
				<!-- <c-detail-item label="充值时间">
					{{detailData.create_date}}
				</c-detail-item> -->
				<c-detail-item label="充值时间">
					{{detailData.payment_date}}
				</c-detail-item>
				<c-detail-item label="支付凭证" full v-if="detailData.payment_type=='银行转账'">
					<c-image v-for="(medias, j) in detailData.pay_voucher_url_list" :key="j" class="img" :src="medias" size="80" preview></c-image>
				</c-detail-item>
				<c-detail-item label="会员信息" >
					<template v-slot="{data}">
			            <span>
			              {{detailData.user_manage_mobilephone}}
			              <span v-if="detailData.nick_name && detailData.nick_name!=''">({{detailData.nick_name}})</span>
			            </span>
					</template>
				</c-detail-item>
				<c-detail-item label="审批状态" >
					<template v-slot="{data}">
						<span style="color:red" v-if="detailData.check_state==3">审批驳回</span>
						<span style="color:green" v-if="detailData.check_state==2">审批通过</span>
						<span style="color:gray" v-if="detailData.check_state==1">待审批</span>
					</template>
				</c-detail-item>
				<c-detail-item label="审批驳回原因" v-if="detailData.check_state==3">
					 <span style="color:red">{{detailData.reject_reason}}</span>
				</c-detail-item>
			</c-detail>
			<template slot="button">
				<c-button size="m" v-if="detailData.payment_state==2 && detailData.check_state == 1 && detailData.payment_type=='银行转账'" power="b_member_recharge_record_approval" @click="approval(detailData,2)">审批</c-button>
				<c-button size="m" v-if="detailData.payment_state==2 && detailData.check_state == 1 && detailData.payment_type=='银行转账'" power="b_member_recharge_record_approval" hollow @click="approval(detailData,4)">驳回</c-button>
			</template>
		</module>
		<c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="orderApprovalHandle">
			<div class="approval-eason">
				<textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'member_recharge_record_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {},
				approvalReason: ''
			}
		},
		mounted() {
			this.detail();
		},

		computed: {
			...mapState(['systemConfig'])
		},

		watch: {
			id() {
				this.detail();
			}
		},

		methods: {
			detail() {
				this.request({
					url: '/user/recharge/record/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			},
			approval(val,state) {
				if(state == 4){
					this.$refs.approvalReason.open();
				}else if(state == 2){
					this.$confirm({
						text: '是否确认充值单【'+val.record_number+'】客户已完成支付，审批通过即会将充值金额充值进入会员账号',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/user/recharge/record/approval',
								data: {id:val.id,check_state:state},
								loading: true,
								success: data => {
									this.$message({
										text: '审批通过成功',
										icon: 'success'
									});
									this.$bus.$emit('member_recharge_record_list.update', {})
									this.detail();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}
			},
			orderApprovalHandle(stop){

				if (!this.approvalReason.trim()) {
					this.$message({
						text: '请填写驳回原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/user/recharge/record/approval',
					data: {
						id:this.id,
						check_state:3,
						reject_reason:this.approvalReason.trim()
					},
					loading: true,
					success: data => {
						this.$message({
							text: '审批驳回成功',
							icon: 'success'
						});
						this.$bus.$emit('member_recharge_record_list.update', {})
						this.detail();
					}
				});
			},
		}
	}
</script>